import React from "react";
import { Modal, Button } from "react-bootstrap";

import { inviteUserToComp } from "../https_handler/apiHandler";

import "bootstrap/dist/css/bootstrap.min.css";
import "./SharedModal.css";

const InviteUserModal = ({ show, handleClose, user, activeCompetition, showErrorModal }) => {
    const [isLoading, setLoading] = React.useState(false);
    const [inputEmail, setInputEmail] = React.useState("");

    const handleInviteUser = async () => {
        if (isLoading) return;

        if (!isValidEmail(inputEmail)) return;

        setLoading(true);
        const { error } = await inviteUserToComp(user, activeCompetition.compInfo.compId, inputEmail);

        if (error)
            showErrorModal(error);

        setInputEmail("");

        setLoading(false);
    }

    const hideModal = () => {
        if (!isLoading)
            handleClose();
    }

    const getActiveCompTitle = () => {
        if (activeCompetition)
            return activeCompetition.compInfo.title;
        return '';
    }

    const validateAndSetEmail = (email) => {
        setInputEmail(email);
    }

    const isValidEmail = (email) => {
        const regexp = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regexp.test(email)
    }

    const getInputClassName = () => {
        if (!inputEmail) return 'modal-input';
        return isValidEmail(inputEmail) ? 'modal-input valid' : 'modal-input invalid';
    }

    return (
        <Modal
            size="lg"
            centered
            show={show}
            onHide={hideModal}
            className="custom-modal"
        >
            <Modal.Header closeButton>
                <h2 className="modal-heading">Invite User to Competition</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="modal-form-group">
                    <p className="modal-text">
                        Send an invitation to join "{getActiveCompTitle()}"
                    </p>
                </div>
                
                <div className="modal-form-group">
                    <label className="modal-label" htmlFor="email-input">
                        User's Email Address
                    </label>
                    <input
                        id="email-input"
                        type="email"
                        className={getInputClassName()}
                        value={inputEmail}
                        onChange={(event) => validateAndSetEmail(event.target.value)}
                        placeholder="Enter email address..."
                        disabled={isLoading}
                    />
                    {inputEmail && !isValidEmail(inputEmail) && (
                        <p style={{ color: 'var(--error)', fontSize: '0.75rem', marginTop: 'var(--space-xs)' }}>
                            Please enter a valid email address
                        </p>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button 
                    className="modal-btn secondary" 
                    onClick={hideModal}
                    disabled={isLoading}
                >
                    Cancel
                </button>
                <button 
                    className="modal-btn primary" 
                    onClick={handleInviteUser}
                    disabled={isLoading || !isValidEmail(inputEmail)}
                >
                    {isLoading ? (
                        <span className="modal-loading">
                            <span>Sending...</span>
                        </span>
                    ) : (
                        'Send Invitation'
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default InviteUserModal;